/**
 * @generated SignedSource<<293d4c28b53c1c811acc141bd45b66c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addProfanityRulePanel_ProfanityFilterRulesListQuery$variables = Record<PropertyKey, never>;
export type addProfanityRulePanel_ProfanityFilterRulesListQuery$data = {
  readonly profanityFilterRules: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    } | null> | null;
  } | null;
};
export type addProfanityRulePanel_ProfanityFilterRulesListQuery = {
  response: addProfanityRulePanel_ProfanityFilterRulesListQuery$data;
  variables: addProfanityRulePanel_ProfanityFilterRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "ProfanityFilterRulesConnection",
    "kind": "LinkedField",
    "name": "profanityFilterRules",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfanityFilterRule",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "profanityFilterRules(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addProfanityRulePanel_ProfanityFilterRulesListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addProfanityRulePanel_ProfanityFilterRulesListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "202bf31c25e5015d1de8c7abafc6ccb5",
    "id": null,
    "metadata": {},
    "name": "addProfanityRulePanel_ProfanityFilterRulesListQuery",
    "operationKind": "query",
    "text": "query addProfanityRulePanel_ProfanityFilterRulesListQuery {\n  profanityFilterRules(first: 200) {\n    nodes {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38ee03510a682be5d5904aa209ce9aaa";

export default node;
